import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';
import { BaseService, Page } from 'yellowfin-ui-lib';
import { Product, ProductsSearch, Taxonomy } from 'yf-commerce-model-ui-lib';


export class TaxonomyService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getTaxoFeatured(): Promise<Taxonomy[]> {
		return this.mapResponse(this.http.get(`/ws/catalog/taxo/featured`), Taxonomy);
	}

	getTaxoVetrina(): Promise<Taxonomy> {
		return this.mapResponse(this.http.get(`/ws/catalog/taxo/route/vetrina`), Taxonomy);
	}

	getTaxonomyProducts(search: ProductsSearch, page: Page): Promise<Product[]> {
		return this.mapResponse(this.http.post(`/ws/catalog/search/${page.start}/${page.stop}`, classToPlain(search)), Product);
	}

	//product special collection
	getProductSpecials(slug: string): Promise<Product[]> {
		return this.mapResponse(this.http.get(`/ws/catalog/product/selection/${slug}`), Product);
	}
}
